/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Params, ParamsInterface, GeneticsConstructor } from "../Params";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "maleGenesProbability",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "femaleGenesProbability",
            type: "uint32",
          },
          {
            internalType: "uint32[13]",
            name: "geneticSequenceSignature",
            type: "uint32[13]",
          },
          {
            internalType: "uint32[72]",
            name: "maxValues",
            type: "uint32[72]",
          },
        ],
        internalType: "struct GeneticsConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "uint32",
        name: "maleGenesProbability",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "femaleGenesProbability",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "maleGenesProbability",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "femaleGenesProbability",
            type: "uint32",
          },
          {
            internalType: "uint32[13]",
            name: "geneticSequenceSignature",
            type: "uint32[13]",
          },
          {
            internalType: "uint32[72]",
            name: "maxValues",
            type: "uint32[72]",
          },
        ],
        internalType: "struct GeneticsConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ParamsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ParamsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Params__factory extends ContractFactory {
  constructor(...args: ParamsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Params";
  }

  deploy(
    input: GeneticsConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Params> {
    return super.deploy(input, overrides || {}) as Promise<Params>;
  }
  getDeployTransaction(
    input: GeneticsConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): Params {
    return super.attach(address) as Params;
  }
  connect(signer: Signer): Params__factory {
    return super.connect(signer) as Params__factory;
  }
  static readonly contractName: "Params";
  public readonly contractName: "Params";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ParamsInterface {
    return new utils.Interface(_abi) as ParamsInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Params {
    return new Contract(address, _abi, signerOrProvider) as Params;
  }
}
